<template>
  <div>
    <div>
      <v-data-table
        :headers="headers"
        :loading="loadingLists"
        :items="lists"
        hide-actions
        class="elevation-1 mt-2"
      >
        <template slot="items" slot-scope="props">
          <!--
            当面対応しない
            <tr @click="openModal(props.item)" style="cursor: pointer;">
          -->
          <tr>
            <td class="text-xs-left">{{ props.item.getListName() }}</td>
            <td class="text-xs-left">
              <v-chip
                :color="createChipColor(props.item.resourceType)"
                outline
                disabled
                text-color="black"
              >
                {{ props.item.getResourceTypeName() }}
              </v-chip>
              <span>
                {{ props.item.resourceName }}
              </span>
            </td>

            <td class="text-xs-left">{{ props.item.getBlackOrWhite() }}</td>
            <td class="text-xs-left">{{ props.item.ipRangeCount }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <IpRangeListModal
      v-model="displayIPRangeListModal"
      :list="items"
      :loading="loadingItems"
      :title="IPRangeListTitle"
    />
  </div>
</template>
<script>
import IpRangeListModal from './IPRangeListModal'
import JAPANESE from '@/constants/japanese'
export default {
  components: { IpRangeListModal },
  props: {
    lists: {
      type: Array,
      default: () => [],
    },
    loadingLists: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loadingItems: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        { text: JAPANESE.listName, value: 'name' },
        { text: '適用範囲', value: 'resourceName' },
        { text: JAPANESE.blackOrWhite, value: 'blackOrWhite' },
        { text: JAPANESE.ipRangeCount, value: 'ipRangeCount' },
      ],
      displayIPRangeListModal: false,
      IPRangeListTitle: '',
    }
  },
  methods: {
    openModal(item) {
      this.createIPRangeListTitle(item)
      // 20190517 一旦不要機能
      // this.$emit('getItems', item.id)
      this.displayIPRangeListModal = true
    },
    createIPRangeListTitle(item) {
      this.IPRangeListTitle = item.name + ' の IP'
    },
    createChipColor(type) {
      let result = ''
      switch (type) {
        case 'advertiser':
          result = 'pink'
          break
        case 'oem':
          result = 'success'
          break
        case 'agency':
          result = 'orange'
          break
        case 'insertion_order':
          result = 'primary'
          break
      }
      return result
    },
  },
}
</script>
